/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useLocation, useParams } from 'js/lib/useRouter';

import { Grid } from '@coursera/cds-core';

import { ROUTE_ARGUMENTS } from 'bundles/admin-shared/analytics/constants';
import { AdminRouteNames, getAdminV2Routes } from 'bundles/admin-v2/constants/routes';
import { GROUP } from 'bundles/admin/constants/AdminRouteNames';
import AdminPermission from 'bundles/admin/utils/AdminPermission';
import AdminLinkGridItem from 'bundles/composable-page-header-admin/components/AdminLinkGridItem';
import { useAdminSelectedPartnerSlug } from 'bundles/composable-page-header-admin/contexts/AdminSelectedPartnerSlugContext';
import useAdminHeaderPermissions from 'bundles/composable-page-header-admin/providers/AdminHeaderPermissionsProvider';

type AdminNavItem = {
  isHidden: boolean;
  href?: string;
  name: string;
  target: string;
  openInNewWindow?: boolean;
};

const styles = {
  wrapper: css`
    margin-right: var(--cds-spacing-100);
  `,
};

type Props = {
  handleGroupsClick: () => void;
};

const AdminRightNavGridItem = ({ handleGroupsClick }: Props) => {
  const location = useLocation();
  const params = useParams();

  const routeShortName: string | undefined = params[ROUTE_ARGUMENTS.INSTITUTION_SLUG];

  const adminPermissionData = useAdminHeaderPermissions();
  const adminSelectedPartnerSlugData = useAdminSelectedPartnerSlug();

  const userPref = adminSelectedPartnerSlugData?.adminInfo?.UserPreference?.me;
  const partner =
    userPref?.__typename === 'UserPreference_AdminSelectedPartnerUserPreference' ? userPref.partner : undefined;

  const adminPageList: Array<AdminNavItem> = getAdminV2Routes(
    routeShortName || partner?.slug,
    adminPermissionData?.adminPermissions ?? new AdminPermission({})
  );

  return (
    <Grid item container spacing={16} justifyContent="flex-end" css={styles.wrapper}>
      {adminPageList.map((item: AdminNavItem) => {
        if (!item.isHidden) {
          return (
            <AdminLinkGridItem
              key={`admin-link-grid-item-${item.name}`}
              label={item.name}
              isCurrent={!!(item.href && location?.pathname.includes(item.href))}
              href={item.href}
              onClick={
                item.target === AdminRouteNames.MY_GROUP || item.target === GROUP ? handleGroupsClick : undefined
              }
            />
          );
        } else {
          return null;
        }
      })}
    </Grid>
  );
};

export default AdminRightNavGridItem;
